var _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonkPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 30,
    viewBox: "0 0 110 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1335_26869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30598 10.1468C1.79445 8.25104 2.57868 7.8327 3.93916 8.77868C4.34749 9.06323 4.70622 9.42881 5.04777 9.7925C5.32444 10.0884 5.62974 10.4031 5.77285 10.7667C6.17164 11.7787 6.72499 11.5073 7.34513 11.0324C8.0454 10.9627 8.23049 10.6066 8.06448 9.93949C7.81261 8.9332 7.75537 7.89866 7.74774 6.86411C7.75346 6.61348 7.73819 6.36097 7.76872 6.11411C7.81452 5.7278 7.9519 5.35657 8.35451 5.22466C8.76666 5.08898 9.15401 5.18132 9.48983 5.49979C10.4668 6.43069 11.0831 7.59338 11.6651 8.77303C11.9017 9.25356 12.0925 9.69451 12.7756 9.37604C12.913 9.31197 13.1534 9.39112 13.3175 9.46273C16.7082 10.9458 18.7785 13.4935 19.5723 17.0645C18.3988 16.5406 17.2539 16.9213 16.1033 17.1662C16.5078 16.5971 16.1434 16.4238 15.6549 16.2919C14.9222 16.094 14.6322 16.8534 14.0006 16.9382C14.3612 17.4602 14.8688 17.3603 15.3115 17.4433C13.7773 18.246 12.2432 19.0431 10.7129 19.8515C10.2321 20.1059 9.81421 19.9759 9.37535 19.7328C8.43656 19.2127 7.48633 18.7303 6.40634 18.5268C4.78254 18.2196 3.72354 19.2033 4.01739 20.8107C4.2559 22.1185 4.91038 23.2322 5.9274 24.0745C7.19248 25.1223 8.82581 25.6631 10.3466 25.7498C12.455 25.8704 14.6303 25.8157 16.7444 25.3748C15.695 27.4608 14.3708 29.2755 12.0009 30.0538C11.9017 29.9897 11.8025 29.8691 11.7032 29.8672C9.46885 29.8465 7.64088 28.8327 5.9274 27.5588C5.57631 27.2969 5.23095 27.2008 4.80544 27.1706C2.70462 27.0236 0.884285 26.4169 0.113411 24.2064C-0.134643 23.0833 0.0561675 21.9922 0.241254 20.8729C0.493123 19.3559 0.964425 17.9125 1.41665 16.4558C1.93183 15.5494 2.07494 14.6204 1.69332 13.6179C1.54258 13.2184 1.52159 12.7718 1.43954 12.3478C1.1228 11.6317 1.53876 10.8704 1.30598 10.1487V10.1468ZM2.61875 11.334C2.74469 11.9879 2.86871 12.7265 3.03281 13.4539C3.32093 14.7335 3.77506 14.9144 4.92183 14.1889C5.26148 13.974 5.55151 13.6744 5.83009 13.3804C6.07051 13.126 6.08005 12.8132 5.87589 12.5211C5.40649 11.8559 4.95618 11.1776 4.44672 10.5425C4.16241 10.1863 3.80178 9.75481 3.26369 9.98471C2.74469 10.2071 2.63402 10.7234 2.62066 11.3321L2.61875 11.334ZM10.3466 10.6575C10.7664 10.5915 11.5277 10.4897 11.3064 9.74727C10.9896 8.67881 10.4611 7.65368 9.7169 6.78308C9.49938 6.53057 9.09486 6.37228 9.08341 6.93195C9.06242 7.96084 8.97465 9.00104 9.27422 10.013C9.40588 10.4539 9.70163 10.697 10.3466 10.6575ZM6.9864 16.4087C6.8681 16.8817 7.13333 17.2586 7.44244 17.4734C7.81452 17.7316 8.10837 17.2887 8.36787 17.0871C8.9861 16.6103 9.25514 15.9489 9.02617 15.1819C8.92694 14.8522 8.59875 14.7014 8.25529 14.8164C7.48823 15.0726 7.14668 15.6813 6.98831 16.4106L6.9864 16.4087ZM15.0806 12.4232C14.5158 12.5551 13.8976 12.7171 13.8518 13.388C13.806 14.0551 14.5673 14.2812 14.9394 14.2567C15.4775 14.219 16.3953 14.2209 16.4029 13.4031C16.4086 12.736 15.7274 12.5023 15.0825 12.4232H15.0806ZM9.34482 18.0915C10.0451 18.5984 10.5965 18.5475 11.1537 18.3855C11.4323 18.3044 11.749 18.1688 11.7166 17.8541C11.6803 17.4828 11.3159 17.4489 10.9953 17.3999C10.3141 17.2963 10.0336 17.9558 9.34482 18.0915Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7428 25.3738C14.6305 25.8147 12.4534 25.8694 10.3449 25.7488C8.82415 25.6621 7.1889 25.1213 5.92574 24.0735C4.90872 23.2312 4.25424 22.1175 4.01573 20.8097C3.72188 19.2023 4.78088 18.2205 6.40467 18.5258C7.48275 18.7293 8.4349 19.2117 9.37368 19.7318C9.81255 19.9749 10.2304 20.1031 10.7113 19.8506C12.2416 19.0421 13.7757 18.245 15.3098 17.4423C15.5731 17.3499 15.8383 17.2576 16.1036 17.1653C17.2542 16.9203 18.399 16.5396 19.5725 17.0635C20.1468 17.7061 20.3453 18.4636 20.3567 19.3078C20.3758 20.7174 19.9961 22.0327 19.4065 23.2821C18.8818 24.3901 17.9373 25.0534 16.7447 25.3719L16.7428 25.3738ZM18.8283 18.132C18.8818 17.6967 18.4544 17.4913 17.9506 17.446C17.1816 17.3763 16.4432 17.5572 15.7697 17.9341C14.6362 18.5691 14.6191 19.4002 15.7391 20.0258C16.1723 20.2689 16.6588 20.4234 17.132 20.5911C17.4488 20.7023 17.7846 20.674 17.9945 20.3876C18.4429 19.7752 18.7654 19.1043 18.8264 18.132H18.8283Z",
    fill: "#E5E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4155 9.12271C19.8945 9.0888 19.6389 8.89093 19.9136 8.40287C20.7551 6.90663 22.0412 5.86643 23.5371 5.06932C24.0008 4.82246 24.3939 5.08063 24.6686 5.48013C24.9262 5.85513 25.18 6.31304 24.7965 6.67673C23.5447 7.86015 22.0507 8.64972 20.4155 9.12271Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2425 5.34413C17.2941 3.98546 17.7081 2.80958 18.2367 1.67327C18.5076 1.0891 18.8892 0.683949 19.6487 1.00242C20.4272 1.32842 20.5989 1.84852 20.286 2.57779C19.8032 3.69714 19.309 4.8146 18.5229 5.76624C18.2577 6.08659 18.0001 6.64249 17.5135 6.44086C17.046 6.24865 17.2635 5.67579 17.2425 5.34413Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6437 2.31943C14.6514 3.26541 14.5559 4.19254 14.2774 5.09895C14.1934 5.37031 14.1114 5.68689 13.7832 5.71704C13.5008 5.74531 13.3596 5.47772 13.2489 5.25159C12.5372 3.81566 12.3006 2.28174 12.3578 0.702592C12.3712 0.320054 12.5372 -0.0511769 13.0791 0.0845015C13.5866 0.212642 14.369 -0.307458 14.5254 0.638522C14.6151 1.19066 14.6094 1.75787 14.6456 2.31754L14.6437 2.31943Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7791 7.05054C14.6799 7.55368 14.4032 7.85707 13.8861 7.84012C13.3709 7.82316 13.0751 7.52542 13.0713 7.01474C13.0675 6.49841 13.3823 6.18936 13.8804 6.18371C14.4318 6.17617 14.7047 6.54175 14.7791 7.05054Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9676 8.56775C16.4409 8.47164 16.1223 8.21348 16.128 7.69714C16.1337 7.18081 16.4352 6.89061 16.9485 6.87554C17.4694 6.86046 17.7938 7.16385 17.811 7.65757C17.83 8.20594 17.4541 8.47164 16.9676 8.56775Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8646 8.93359C19.4027 9.00332 19.7405 9.28033 19.7233 9.77781C19.7042 10.3055 19.3607 10.656 18.8055 10.6202C18.3056 10.5881 18.0174 10.2508 18.0403 9.74201C18.0632 9.22191 18.4048 8.99201 18.8646 8.93359Z",
    fill: "#9A9AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6191 11.3337C2.63245 10.727 2.74312 10.2087 3.26213 9.98638C3.80021 9.75648 4.16084 10.188 4.44515 10.5442C4.95462 11.1773 5.40493 11.8576 5.87432 12.5228C6.0804 12.8149 6.07086 13.1277 5.82853 13.3821C5.54994 13.6761 5.25991 13.9757 4.92027 14.1905C3.7735 14.916 3.32128 14.7351 3.03125 13.4556C2.86715 12.7282 2.74503 11.9895 2.61719 11.3356L2.6191 11.3337Z",
    fill: "#1C1C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3469 10.6592C9.70193 10.6988 9.40618 10.4576 9.27452 10.0147C8.97494 9.00468 9.06081 7.9626 9.08371 6.9337C9.09515 6.37403 9.50158 6.53232 9.7172 6.78483C10.4633 7.65355 10.9899 8.68056 11.3066 9.74903C11.5261 10.4915 10.7667 10.5932 10.3469 10.6592Z",
    fill: "#1C1C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98673 16.4096C7.1451 15.6803 7.48665 15.0716 8.25371 14.8153C8.59717 14.7004 8.92536 14.853 9.02458 15.1809C9.25356 15.9479 8.98451 16.6093 8.36629 17.0861C8.10678 17.2858 7.81484 17.7305 7.44085 17.4724C7.13174 17.2576 6.86652 16.8826 6.98482 16.4077L6.98673 16.4096Z",
    fill: "#1C1C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0802 12.4258C15.7232 12.503 16.4063 12.7386 16.4006 13.4057C16.393 14.2235 15.4752 14.2216 14.9371 14.2593C14.565 14.2857 13.8056 14.0577 13.8495 13.3906C13.8953 12.7198 14.5154 12.5577 15.0783 12.4258H15.0802Z",
    fill: "#1C1C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1037 17.1689C15.8385 17.2612 15.5733 17.3535 15.3099 17.4459C14.8692 17.363 14.3597 17.4609 14.001 16.9408C14.6326 16.856 14.9226 16.0966 15.6553 16.2945C16.1438 16.4264 16.5101 16.5998 16.1037 17.1689Z",
    fill: "#1C1C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34473 18.0932C10.0336 17.9575 10.314 17.298 10.9952 17.4016C11.3177 17.4506 11.6802 17.4845 11.7165 17.8558C11.747 18.1705 11.4322 18.3061 11.1536 18.3872C10.5964 18.5511 10.045 18.6001 9.34473 18.0932Z",
    fill: "#1C1C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8283 18.1342C18.7673 19.1066 18.4448 19.7774 17.9964 20.3899C17.7865 20.6782 17.4507 20.7046 17.1339 20.5934C16.6607 20.4276 16.1742 20.2712 15.741 20.0281C14.621 19.4024 14.6381 18.5695 15.7715 17.9364C16.4432 17.5595 17.1816 17.3786 17.9525 17.4483C18.4562 17.4935 18.8837 17.6989 18.8302 18.1342H18.8283Z",
    fill: "#1C1C35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1335_26869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.007 8.48047L94.4414 15.0838L100.007 21.6305H96.5733L92.7246 17.1025L92.0076 17.9704V21.6305H89.272V8.48047H92.0076V13.914L96.5733 8.48047H100.007Z",
    fill: "#9A9AA5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1335_26869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4168 16.9327V8.48047H81.1336V21.6305H78.53L72.5115 13.216V21.6305H69.7759V8.48047H72.3606L78.4168 16.9327Z",
    fill: "#9A9AA5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1335_26869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.121 8.48047C57.014 8.48047 57.8504 8.65656 58.6303 9.00873C59.4101 9.34833 60.0893 9.81371 60.6678 10.4049C61.2464 10.996 61.7055 11.6941 62.0451 12.499C62.3847 13.2914 62.5545 14.1404 62.5545 15.046C62.5545 15.9516 62.3847 16.8069 62.0451 17.6119C61.7055 18.4169 61.2464 19.1149 60.6678 19.7061C60.0893 20.2972 59.4101 20.7689 58.6303 21.1211C57.8504 21.4607 57.014 21.6305 56.121 21.6305C55.2406 21.6305 54.4104 21.4607 53.6306 21.1211C52.8508 20.7689 52.1653 20.2972 51.5742 19.7061C50.9956 19.1149 50.5365 18.4169 50.1969 17.6119C49.8573 16.8069 49.6875 15.9516 49.6875 15.046C49.6875 14.1404 49.8573 13.2914 50.1969 12.499C50.5365 11.6941 50.9956 10.996 51.5742 10.4049C52.1653 9.81371 52.8508 9.34833 53.6306 9.00873C54.4104 8.65656 55.2406 8.48047 56.121 8.48047ZM56.121 19.1589C56.6367 19.1589 57.1209 19.052 57.5737 18.8382C58.0265 18.6244 58.4164 18.3288 58.7435 17.9515C59.0831 17.5742 59.3472 17.1402 59.5359 16.6497C59.7245 16.1466 59.8188 15.612 59.8188 15.046C59.8188 14.48 59.7245 13.9518 59.5359 13.4612C59.3472 12.9581 59.0831 12.5242 58.7435 12.1594C58.4164 11.7821 58.0265 11.4865 57.5737 11.2727C57.1209 11.0589 56.6367 10.952 56.121 10.952C55.6179 10.952 55.1399 11.0589 54.6871 11.2727C54.2343 11.4865 53.8381 11.7821 53.4985 12.1594C53.1715 12.5242 52.9137 12.9581 52.725 13.4612C52.5364 13.9518 52.442 14.48 52.442 15.046C52.442 15.612 52.5364 16.1466 52.725 16.6497C52.9137 17.1402 53.1715 17.5742 53.4985 17.9515C53.8381 18.3288 54.2343 18.6244 54.6871 18.8382C55.1399 19.052 55.6179 19.1589 56.121 19.1589Z",
    fill: "#9A9AA5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1335_26869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2944 12.3292C42.2944 12.694 42.2378 13.065 42.1246 13.4424C42.0114 13.8071 41.8227 14.1782 41.5586 14.5555C42.0743 14.9831 42.4516 15.4737 42.6906 16.0271C42.9421 16.5679 43.0679 17.1151 43.0679 17.6685C43.0679 18.2974 42.9233 18.9011 42.634 19.4797V19.4608C42.3195 20.0897 41.8667 20.6117 41.2756 21.0267C40.697 21.4292 39.9738 21.6305 39.1059 21.6305H32.9932V8.48047H37.3325L38.7475 8.49934C39.2757 8.53707 39.7537 8.66913 40.1813 8.89553C40.6215 9.12193 40.9926 9.41122 41.2945 9.7634C41.6089 10.1156 41.8542 10.5118 42.0303 10.952C42.2063 11.3922 42.2944 11.8513 42.2944 12.3292ZM35.7288 13.6688H38.4645C38.7663 13.6688 39.0242 13.543 39.238 13.2914C39.4518 13.0273 39.5587 12.7066 39.5587 12.3292C39.5587 11.9645 39.4518 11.6438 39.238 11.3671C39.0242 11.0903 38.7663 10.952 38.4645 10.952H35.7288V13.6688ZM39.1059 19.1589C39.4455 19.1589 39.7285 19.0143 39.9549 18.725C40.1939 18.4232 40.3134 18.0647 40.3134 17.6496C40.3134 17.2471 40.1939 16.9012 39.9549 16.612C39.7285 16.3101 39.4455 16.1592 39.1059 16.1592H35.7288V19.1589H39.1059Z",
    fill: "#9A9AA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1335_26869",
    x: 79.272,
    y: 8.48047,
    width: 30.7349,
    height: 33.1484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1335_26869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1335_26869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1335_26869",
    x: 59.7759,
    y: 8.48047,
    width: 31.3579,
    height: 33.1484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1335_26869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1335_26869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1335_26869",
    x: 39.6875,
    y: 8.48047,
    width: 32.8672,
    height: 33.1484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1335_26869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1335_26869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1335_26869",
    x: 22.9932,
    y: 8.48047,
    width: 30.0747,
    height: 33.1484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1335_26869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1335_26869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1335_26869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 30,
    fill: "white",
    transform: "translate(-0.00683594 0.0546875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonkPartner);
export default __webpack_public_path__ + "static/media/bonk_partner.81664604.svg";
export { ForwardRef as ReactComponent };